const filter = (value, type?: string): string => {
  if (isNaN(value)) {
    return ''
  }

  let fractionDigits = 2

  switch (type) {
    case 'integer':
      fractionDigits = 0
  }

  let modifiedValue = parseFloat(value.toFixed(fractionDigits))

  if (type === 'pt-BR') {
    return `${modifiedValue.toLocaleString('pt-BR')}%`
  }

  return `${parseFloat(value.toFixed(fractionDigits))}%`
}

export default filter
